export default __webpack_public_path__ + "static/media/placeholder_business02-jp-web.bc57ba50.png";